// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ck.ck-reset.ck-editor {
    color: black;
    margin-bottom: 8px;
}

.ck.ck-editor__main {
    max-height: 500px;
    overflow-y: scroll;
    overflow-x: hidden;
}

.react-datepicker__navigation-icon--next::before,
.react-datepicker__navigation-icon--previous::before {
    top: 12px;
}

.ck.ck-editor__main::-webkit-scrollbar-track {
    background: #d3dbe5;
}
.ck.ck-editor__main::-webkit-scrollbar-thumb {
    border-radius: 0px;
    background: lightsteelblue;
}
.ck.ck-editor__main::-webkit-scrollbar-thumb:hover{
    background: #899cb6;
}

.table {
    color: unset; /* disables default bootstrap rule */
}`, "",{"version":3,"sources":["webpack://./src/client/components/ckeditor/styles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;;IAEI,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY,EAAE,oCAAoC;AACtD","sourcesContent":[".ck.ck-reset.ck-editor {\n    color: black;\n    margin-bottom: 8px;\n}\n\n.ck.ck-editor__main {\n    max-height: 500px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n}\n\n.react-datepicker__navigation-icon--next::before,\n.react-datepicker__navigation-icon--previous::before {\n    top: 12px;\n}\n\n.ck.ck-editor__main::-webkit-scrollbar-track {\n    background: #d3dbe5;\n}\n.ck.ck-editor__main::-webkit-scrollbar-thumb {\n    border-radius: 0px;\n    background: lightsteelblue;\n}\n.ck.ck-editor__main::-webkit-scrollbar-thumb:hover{\n    background: #899cb6;\n}\n\n.table {\n    color: unset; /* disables default bootstrap rule */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
